// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {"412": "eb2d0cbb0f31b3e0","702": "5b9d7645812c5411",}[chunkId] + ".css"
}